export default {
  mounted(){
    this.$nextTick(()=>{
      this.sendDocumentHeightToParent();
    })
  }
}
